export default {
  title: 'Acciones rápidas',
  send_push_notification: {
    label: 'Enviar notificación push',
    description: 'Crear una nueva campaña',
  },
  email_campaign: {
    label: 'Campaña de correo',
    description: 'Enviar a suscriptores',
  },
  view_analytics: {
    label: 'Ver análisis',
    description: 'Rendimiento de campaña',
  },
};
